module.exports = __webpack_public_path__ + "ca854e6d0785ba4b9d715049c0bdbcb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/hipster.png
// module id = 333
// module chunks = 0